// Generated by purs version 0.15.14
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
var WsMessageIsSymbol = {
    reflectSymbol: function () {
        return "WsMessage";
    }
};
var WsConnectionError = /* #__PURE__ */ (function () {
    function WsConnectionError() {

    };
    WsConnectionError.value = new WsConnectionError();
    return WsConnectionError;
})();
var WsDecodeError = /* #__PURE__ */ (function () {
    function WsDecodeError(value0) {
        this.value0 = value0;
    };
    WsDecodeError.create = function (value0) {
        return new WsDecodeError(value0);
    };
    return WsDecodeError;
})();
var WsMessage = /* #__PURE__ */ (function () {
    function WsMessage(value0) {
        this.value0 = value0;
    };
    WsMessage.create = function (value0) {
        return new WsMessage(value0);
    };
    return WsMessage;
})();
var WsError = /* #__PURE__ */ (function () {
    function WsError(value0) {
        this.value0 = value0;
    };
    WsError.create = function (value0) {
        return new WsError(value0);
    };
    return WsError;
})();
var WsClose = /* #__PURE__ */ (function () {
    function WsClose(value0) {
        this.value0 = value0;
    };
    WsClose.create = function (value0) {
        return new WsClose(value0);
    };
    return WsClose;
})();
var genericWsEvent_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new WsMessage(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new WsError(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new WsClose(x.value0.value0);
        };
        throw new Error("Failed pattern match at Fusion.MonadWebsocket (line 42, column 1 - line 42, column 42): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof WsMessage) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof WsError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof WsClose) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Fusion.MonadWebsocket (line 42, column 1 - line 42, column 42): " + [ x.constructor.name ]);
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericWsEvent_);
var genericWsError_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return WsConnectionError.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new WsDecodeError(x.value0);
        };
        throw new Error("Failed pattern match at Fusion.MonadWebsocket (line 47, column 1 - line 47, column 34): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof WsConnectionError) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof WsDecodeError) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Fusion.MonadWebsocket (line 47, column 1 - line 47, column 34): " + [ x.constructor.name ]);
    }
};
var showWsError = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericWsError_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "WsConnectionError";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Argonaut_Decode_Error.showJsonDecodeError))({
        reflectSymbol: function () {
            return "WsDecodeError";
        }
    })))
};
var genericShowSum = /* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showWsError))({
    reflectSymbol: function () {
        return "WsError";
    }
}))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "reason";
    }
})(Data_Show.showString))(Data_Show.showInt))))({
    reflectSymbol: function () {
        return "WsClose";
    }
}));
var showWsEvent = function (dictShow) {
    return {
        show: genericShow(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))(WsMessageIsSymbol))(genericShowSum))
    };
};
var hoistWsCommand = function (nat) {
    return function (cmd) {
        return {
            sendMessage: function ($67) {
                return nat(cmd.sendMessage($67));
            },
            close: nat(cmd.close)
        };
    };
};
var createWs = function (dict) {
    return dict.createWs;
};
export {
    createWs,
    WsMessage,
    WsError,
    WsClose,
    WsConnectionError,
    WsDecodeError,
    hoistWsCommand,
    genericWsEvent_,
    showWsEvent,
    genericWsError_,
    showWsError
};
